// extracted by mini-css-extract-plugin
module.exports = {"search":"searchContainer_search__Z8MFl"};